import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import { ChevronRightIcon, PlusIcon } from '@domain-group/fe-co-icon';
import { RowButton } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './option-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var immediateColours = {
  hoverBackground: styles.immediateBackground,
  hoverText: styles.immediateText
};
var Appearance = {
  multi: {
    icon: PlusIcon
  },
  single: {
    icon: null
  },
  immediate: {
    icon: ChevronRightIcon,
    colours: immediateColours
  }
};
var OptionCard = _ref => {
  var icon = _ref.icon,
    title = _ref.title,
    label = _ref.label,
    searchText = _ref.searchText,
    appearanceName = _ref.appearance,
    onClick = _ref.onClick,
    selected = _ref.selected;
  var appearance = Appearance[appearanceName] || Appearance.multi;
  var Icon = appearance.icon;
  return ___EmotionJSX(RowButton, {
    onClick: onClick,
    leftIcon: icon,
    selected: selected,
    title: ___EmotionJSX(Highlighter, {
      css: styles.title,
      searchWords: [searchText],
      textToHighlight: title,
      autoEscape: true
    }),
    label: ___EmotionJSX("div", {
      css: styles.label
    }, label),
    rightIcon: Icon && ___EmotionJSX(Icon, null),
    colours: appearance.colours
  });
};
OptionCard.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  searchText: PropTypes.string,
  appearance: PropTypes.oneOf(['multi', 'single', 'immediate']),
  selected: PropTypes.bool,
  icon: PropTypes.node,
  onClick: PropTypes.func
};
OptionCard.defaultProps = {
  title: '',
  label: '',
  searchText: '',
  selected: false,
  icon: undefined,
  appearance: 'multi',
  onClick: () => {}
};
export default OptionCard;